import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "error-summary-container",
  class: "govuk-error-summary",
  "aria-labelledby": "error-summary-title",
  role: "alert",
  tabindex: "-1",
  "data-module": "govuk-error-summary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "govuk-error-summary__title",
  id: "error-summary-title"
}, " There is a problem ", -1)
const _hoisted_3 = { class: "govuk-error-summary__body" }
const _hoisted_4 = {
  key: 0,
  class: "govuk-error-summary__body"
}
const _hoisted_5 = { class: "govuk-list govuk-error-summary__list" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.formErrorsExist)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formErrorData, (field, index) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: index,
              class: "govuk-list govuk-error-summary__list"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.errors, (error, eIndex) => {
                return (_openBlock(), _createElementBlock("li", { key: eIndex }, [
                  _createVNode(_component_router_link, {
                    to: { hash: _ctx.errorAnchor(field) }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(error.error), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.nuxeoErrorData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                (_ctx.nuxeoErrorData.field)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        to: { hash: _ctx.nuxeoErrorAnchor(_ctx.nuxeoErrorData.field) }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.nuxeoErrorData.message), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(_ctx.nuxeoErrorData.message), 1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}